import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  size?: number;
  className?: string;
}

// The stacked-documents glyph marking the "frequency estimated from scenario library" band,
// exported from Figma 17651:10850 (CRPD-7273). Gradient-filled with the Cydea brand ramp, same
// id-per-instance approach as SparkleSvg.
export const ScenarioLibrarySvg: React.FC<Props> = ({ size = 16, className }) => {
  const { colors } = useTheme();
  const id = `scenariolibrary_${Math.random().toString(36).slice(2)}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.6 4C1.6 3.55817 1.24183 3.2 0.8 3.2C0.358172 3.2 0 3.55817 0 4V14.4C0 15.284 0.716 16 1.6 16H12C12.4418 16 12.8 15.6418 12.8 15.2C12.8 14.7582 12.4418 14.4 12 14.4H1.6V4ZM14.4 0H4.8C3.916 0 3.2 0.716 3.2 1.6V11.2C3.2 12.084 3.916 12.8 4.8 12.8H14.4C15.284 12.8 16 12.084 16 11.2V1.6C16 0.716 15.284 0 14.4 0ZM13.6 7.2H5.6V5.6H13.6V7.2ZM10.4 10.4H5.6V8.8H10.4V10.4ZM13.6 4H5.6V2.4H13.6V4Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="18.7544" y2="5.41726" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
